import React, { useContext } from "react";

import OfferIcon from "@components/icons/Offer";
import { TournamentStatisticsButton } from "@features/offer/desktop/buttons";
import { EventContext, LookupContext, SportOfferContext } from "@gp/components";
import { TournamentOffer } from "@gp/offer";
import classnames from "classnames";

export function EventPageSubheaderTitle() {
	const event = useContext(EventContext);
	const sport = useContext(SportOfferContext);
	const { categories, tournaments } = useContext(LookupContext);

	const category = categories.get(event.sportCategoryId);
	const tournament = tournaments.get(event.tournamentId);

	const iconWrapper = "header--event__icon u-icon u-icon--lrg";
	const iconBase = "header--event__icon__inner u-icon--med";

	return (
		<>
			<div className="header--event__icons">
				<OfferIcon
					type="sport"
					sport={sport?.abrv}
					wrapperClassName={classnames(
						"header--event__icon--sport",
						iconWrapper
					)}
					className={iconBase}
				/>
				<OfferIcon
					type="category"
					sport={sport?.abrv}
					category={category?.abrv || ""}
					wrapperClassName={classnames(
						"header--event__icon--category",
						iconWrapper
					)}
					className={iconBase}
				/>
			</div>

			<div className="header--event__content">
				<div className="header--event__subtitle">
					{category?.name || ""}
				</div>
				<h1 className="header--event__title">
					<span className="header--event__title__clip">
						{tournament?.name || ""}
					</span>

					<TournamentStatisticsButton
						tournament={
							tournaments.get(
								event.tournamentId
							) as TournamentOffer
						}
						customBtnClassName="header--event__title__btn btn btn--square btn--square--reset btn--ghost"
						customIconClassName="header--event__title__icon u-icon u-icon--xsml"
					/>
				</h1>
			</div>
		</>
	);
}
